import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { PublicInsoleModel } from "@/app/types/PublicInsoleModel";
import { PublicPatient } from "@/app/types/PublicPatient";

export type ConfiguratorState = {
  patient: PublicPatient | null;
  pairName: string | null;
  isModelMode: boolean;
  model: PublicInsoleModel | null;
  setPatient(patient: PublicPatient | null): void;
  setPairName(name: string | null): void;
  setIsModelMode(value: boolean): void;
  setModel(model: PublicInsoleModel | null): void;
};

export const ConfiguratorStore = create<ConfiguratorState>()(
  devtools((set) => ({
    patient: null,
    pairName: null,
    isModelMode: false,
    model: null,

    setPatient: (patient: PublicPatient | null) => {
      set({ patient });
    },

    setPairName: (name: string | null) => {
      set({ pairName: name });
    },

    setIsModelMode: (value: boolean) => {
      set({ isModelMode: value });
    },

    setModel: (model: PublicInsoleModel | null) => {
      set({ model });
    },
  })),
);
